module.exports = __webpack_public_path__ + "img/task-7.08622d11.png";